module.exports = __webpack_public_path__ + "static/media/time_reminder.70354f64.mp3";